// Handle mobile viewport height
// Add global variable to track current page
window.isHomePage = true; // Default to true since we start on homepage

export function setViewportHeight(forceScroll) {
  // More accurate calculation for iOS Safari and other mobile browsers
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // Check global flag to determine scroll behavior
  if (window.isHomePage && !forceScroll) {
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.overflow = 'hidden';
  } else {
    // Allow scrolling on other pages
    document.body.style.height = '';
    document.body.style.overflow = '';
  }
} 